// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contacts_contact__2IfMn","link":"Contacts_link__3AlkP"};